import type { ChartType } from 'chart.js';
import { Context } from 'chartjs-plugin-datalabels';
import { Anchor } from 'chartjs-plugin-datalabels/types/options';

export interface IChartWithBars {
  title: string;
  source?: string;
  unit?: string;
  colors: string[];
  labels: (string | number)[];
  datasetsLabels: string[];
  data: (string | number)[][];
}

export interface IDonutWithText {
  title: string;
  labels: string[];
  percentages: number[];
  physicals: number[];
  date?: string;
  source?: string;
  unit?: string;
  total?: string;
  colors?: string[];
  textColor?: '#fff' | '#000';
  isPercentsPriority?: boolean;
}

export interface IImageChart {
  title: string;
  subTitle?: string;
  src: string | 'emptyChart';
  shouldGenerate?: boolean;
}

export interface IChartDatasetItem {
  label: string;
  data: number[];
}

export interface IChartWithStackedBars {
  title: string;
  unit: string;
  labels: (string | number)[];
  datasets: IChartDatasetItem[];
  totals: number[];
  colors: string[];
}

export interface ILinesChart {
  title: string;
  labels: string[];
  datasets: IChartDatasetItem[];
  colors: string[];
  withDot?: boolean;
  yAxisBold?: boolean;
  dottedXBorder?: boolean;
  valueFormatter?: (value: string) => string;
}

export interface IMixedChartDatasetItem {
  type: ChartType;
  values: number[];
}

export interface IMixedChart {
  title: string;
  source?: string;
  unit?: string;
  colors: string[];
  labels: (string | number)[];
  datasetsLabels: string[];
  data: IMixedChartDatasetItem[];
}

export const emptyChart = 'emptyChart';

export type Align = 'end' | 'center' | 'start' | Anchor[] | ((context: Context) => Anchor) | undefined;
